export const IMPORT_PACK_INVALID_ENVELOPE = 'IMPORT_PACK_INVALID_ENVELOPE';
export const IMPORT_PACK_INVALID_PAYLOAD = 'IMPORT_PACK_INVALID_PAYLOAD';
export const IMPORT_PACK_COMPANY_MISMATCH = 'IMPORT_PACK_COMPANY_MISMATCH';
export const IMPORT_PACK_UNSUPPORTED_TYPE = 'IMPORT_PACK_UNSUPPORTED_TYPE';
export const IMPORT_PACKS_ACCESS_DENIED = 'IMPORT_PACKS_ACCESS_DENIED';
export const IMPORT_PACK_ALREADY_REJECTED = 'IMPORT_PACK_ALREADY_REJECTED';
